import { render, staticRenderFns } from "./shift-auth-deny.vue?vue&type=template&id=1b7d8ee0"
import script from "./shift-auth-deny.vue?vue&type=script&lang=js"
export * from "./shift-auth-deny.vue?vue&type=script&lang=js"
import style0 from "./shift-auth-deny.vue?vue&type=style&index=0&id=1b7d8ee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports